import {useQuery} from 'react-query'

import {API} from '../../networking/http'
import {QueryMethod} from '../helpers/types'
import {PublicCancelPolicy} from '../venue/get-public-cancel-policy'

export type GetBookingCancelDetailsParams = {
  id: string
}

export type GetBookingCancelDetailsQueryParams = {
  // entity: string | null;
  // entityId: string | null
  // contactToVenue: boolean
  // isAbleToCancel: boolean
}
// Rain check (D450): the venue-wide rain check this booking is under right now. Absent/null on a
// server without rain check, and then the modal behaves exactly as before.
export type BookingCancelRainCheck = {
  modeId?: string | null
  reason?: string | null
  endsAt?: number | string | null
  policyName?: string | null
  customerText?: string | null
  shareReason?: string | null
  refundPercent?: number | null
  cutoffMinutes?: number | null
} | null

// The venue policy's quote. Under a rain check `rainCheck` is true and `refundable` is the only amount
// the modal may print: the server priced it, the client never recomputes it.
export type BookingCancelVenueQuote = {
  policyName?: string | null
  refundable?: number | null
  withheld?: number | null
  refundPercent?: number | null
  paid?: number | null
  rainCheck?: boolean | null
  rainCheckReason?: string | null
  rainCheckPolicyName?: string | null
} | null

export type GetBookingCancelDetailsReturnType = {
  contactToVenue: boolean
  isBookingOwner: boolean
  fitInCancelPolicy: boolean
  isAbleToCancel: boolean
  totalRefundedAmount: number
  cancelPolicy: string
  fee: number
  availableAmountForRefund: number
  bookingWithSubscription: boolean
  totalPaidAmount: number
  subUsageWillBeRefunded: boolean
  rainCheck?: BookingCancelRainCheck
  venueCancelQuote?: BookingCancelVenueQuote
  // The venue's own policy the booking falls under (what a customer may read), or null under the ladder.
  venueCancelPolicy?: Pick<PublicCancelPolicy, 'id' | 'name' | 'customerSummary'> & Partial<PublicCancelPolicy> | null
} | null

export type GetBookingQuery = QueryMethod<GetBookingCancelDetailsParams, GetBookingCancelDetailsQueryParams, GetBookingCancelDetailsReturnType>

export const makeGetBookingEndpoint = ({id}: GetBookingCancelDetailsParams) => `bookings/${id}/cancel-details`

export const getBookingCancelDetailsQuery: GetBookingQuery = ({query, params, ...rest}) => ({
  queryKey: ['getBookingCancelDetailsQuery', query],
  cacheTime: 1000 * 60,
  queryFn: ({queryKey: [_, config]}) => {
    if (params?.id) {
      return API.get<GetBookingCancelDetailsQueryParams, GetBookingCancelDetailsReturnType>(makeGetBookingEndpoint(params!), {
        params: config,
      }).then((res) => res.data)
    }
    return new Promise((res) => res(null))
  },
  ...rest,
})

export const useBookingCancelDetails = (id: string) => {
  return useQuery(
    getBookingCancelDetailsQuery({
      params: {id},
      cacheTime: 0,
    }),
  )
}
